import styled from "styled-components";

const StyledSVGPath = styled.svg`
  path {
    fill: var(--du-color-icon);
   // fill-opacity: 0.7;
    ${({ disabled }) => disabled && `
      fill: var(--du-color-icon-disabled)
    `}
  }
`;
const SVGContainer = styled.div`
  &:hover ${StyledSVGPath} path {
    ${({ disabled, noHover }) => !disabled && !noHover && `
      fill: var(--du-color-hover
);
      stroke: var(--du-color-hover
);
      stroke-width: 1;
    `}
  }
`;

const SVGContainerPath = props => (
  <SVGContainer disabled={props.disabled} noHover={props.noHover}>
    <StyledSVGPath {...props} />
  </SVGContainer>
);

export default SVGContainerPath;